<div class="toolbox row justify-content-between">
  <div class="actions col-is-auto">
    <a [routerLink]="['/pages', 'modules']">
      <img src="assets/logo_d.png" alt="Deebr" style="height: 30px;">
    </a>
    <button id="back-button" nbButton appearance="outline" (click)="goBack()">
      <i class="bi-arrow-left"></i>
    </button>

    <input
      type="text"
      nbInput
      fullWidth
      [(ngModel)]="moduleName"
      (ngModelChange)="onModuleNameChange($event)"
      placeholder="Nom du module"
      class="module-name-input"
    />
  </div>

  @if (showToolbox) {
    <div class="actions col-is-auto">
      <button id="headerUndoButton" nbButton appearance="outline"><i class="bi-arrow-counterclockwise"></i></button>
      <button id="headerRedoButton" nbButton appearance="outline"><i class="bi-arrow-clockwise"></i></button>
      <button id="headerCodeEditorButton" nbButton appearance="outline" status="danger"><i class="bi-code-slash"></i></button>
      <button
        id="headerExportHtmlButton"
        nbButton
        appearance="filled"
        status="danger"
        [disabled]="isManualSave || isLoading"
        [nbSpinner]="isManualSave"
        (click)="saveModuleManually()"
      >
        Enregistrer
      </button>
    </div>
  }

  <div class="mobiledesktopview col-is-auto">
    <button
      nbButton
      nbButtonToggle
      [pressed]="selectedView === 'desktop'"
      (click)="onSelectView('desktop')"
      id="desktopViewButton"
      class="toggle-button"
      [title]="showToolbox ? 'Vue Desktop' : 'Voir Desktop dans Stripo'"
    >
      <i class="bi bi-display"></i>
    </button>

    <button
      nbButton
      nbButtonToggle
      [pressed]="selectedView === 'mobile'"
      (click)="onSelectView('mobile')"
      id="mobileViewButton"
      class="toggle-button"
      [title]="showToolbox ? 'Vue Mobile' : 'Voir Mobile dans Stripo'"
    >
      <i class="bi bi-phone"></i>
    </button>
  </div>
</div>

<button id="openModuleDetailsButton" type="button" style="display: none;"></button>
<button id="webPreviewButton" type="button" style="display: none;"></button>

<div class="notification-zone"></div>
<div class="container">
  <div class="loading-spinner" [class.hiddenspinner]="!isLoading">
    <div class="spinner"></div>
  </div>

  <div class="editor" [class.hiddenspinner]="isLoading">
    <div id="stripoModuleEditorContainer" class="full-height"></div>
  </div>
</div>
